import { FC, useEffect } from "react";

import { EventPlace, trackEngagement } from "helpers/analytics";
import ApplicationSettingsContainer from "routes/settings/integrations/components/ApplicationSettingsContainer";

import { LivechatSettings } from "./LivechatSettings";

export const LivechatSettingsPage: FC = () => {
  useEffect(() => {
    trackEngagement("Settings: App details opened", EventPlace.Settings, {
      appName: "livechat",
    });
  }, []);

  return (
    <ApplicationSettingsContainer title="LiveChat">
      <LivechatSettings />
    </ApplicationSettingsContainer>
  );
};
